import axios from '../../utils/axios'
import { apis } from "../../constants/apis";
import httpService from "../httpService";
import { getStaticConfigs } from "../../helpers/common";

class OrderTaskingService
{
  async GetOrderTasking(payload: any)
  {
    const staticConfigs = await getStaticConfigs();

    if (staticConfigs?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2")
    {
      const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
      return axios.get(`${_url}${apis.orderTasking.orderUserCbd}`, {
        params: payload,
      });
    } else
    {
      return httpService.get(apis.orderTasking.orderUser, {
        params: payload,
      });
    }
  }

  GetOrderTaskingAdmin(payload: any)
  {
    return httpService.get(apis.orderTasking.orderAdmin, {
      params: payload,
    });
  }
}

export default new OrderTaskingService();
